// extracted by mini-css-extract-plugin
export default {"products":"Bt-z","card":"Ct-z","oosMessaging":"Dt-z"};